import { createContext } from 'react';

export interface OnboardingContextType {
  // Wizard 1 state (General onboarding)
  wizard1Completed: boolean;
  wizard1Skipped: boolean;

  // Wizard 2 state (Campaign wizard)
  wizard2Shown: boolean;
  // Track if user explicitly chose "fill manually" in campaign wizard
  wizard2DismissedManually: boolean;

  // UI state
  showWelcomeModal: boolean;
  showMenuTour: boolean;
  showGuidedCursor: boolean;
  showCampaignWizard: boolean;
  showCampaignFormTour: boolean;
  // Step 2: Designs Tour
  showDesignsTour: boolean;
  designsTourStep: number;
  // Step 3: Finalize Tour
  showFinalizeTour: boolean;
  finalizeTourStep: number;

  // Actions for Wizard 1
  setWizard1Completed: () => void;
  setWizard1Skipped: () => void;

  // Actions for Wizard 2
  setWizard2Shown: () => void;

  // UI triggers
  triggerWelcomeModal: () => void;
  closeWelcomeModal: () => void;
  triggerMenuTour: (immediate?: boolean) => void;
  closeMenuTour: () => void;
  triggerGuidedCursor: () => void;
  closeGuidedCursor: () => void;
  triggerCampaignWizard: () => void;
  closeCampaignWizard: () => void;
  triggerCampaignFormTour: () => void;
  closeCampaignFormTour: () => void;
  // Step 2: Designs Tour triggers
  triggerDesignsTour: () => void;
  closeDesignsTour: () => void;
  advanceDesignsTour: () => void;
  setDesignsTourStep: (step: number) => void;
  // Step 3: Finalize Tour triggers
  triggerFinalizeTour: () => void;
  closeFinalizeTour: () => void;
  advanceFinalizeTour: () => void;
  setFinalizeTourStep: (step: number) => void;

  // Reset for "Restart Tour" button
  resetOnboarding: () => void;

  // Start tour based on current route (Wizard 1 or Wizard 2)
  startTour: (currentPath: string) => void;

  // Check if user is first-time (never completed or skipped)
  isFirstTimeUser: boolean;
}

export const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined);

export default OnboardingContext;
